window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.Promise = require('es6-promise').Promise;
    window.moment = require('moment');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.baseURL = '/api';
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

    function refreshToken(){
        axios.get('/refresh-csrf').then(function(data){
            console.log("csrf --- refresh");
        	//console.log(data.data);
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = data.data;
        });
    }

    setInterval(refreshToken, 360000);

} else {
    console.error('CSRF token not found');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });


Number.prototype.abbr = function (mass = false) {
    const notations = mass ? ['g', 'kg', 't', 'kt', 'Mt', 'Gt', 'Tt', 'Pt', 'Et'] : ['', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'],
    i = this == 0 ? 0 : Math.floor(Math.log(Math.abs(this)) / Math.log(1000));
    return `${parseFloat((this / Math.pow(1000, i)).toFixed(3).slice(0,4))}${notations[i]}`;
};


window.isElectron = function () {
    // Renderer process
    if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
        return true;
    }
    // Main process
    if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
        return true;
    }
    // Detect the user agent when the `nodeIntegration` option is set to true
    if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
        return true;
    }
    return false;
}
